import type { FC } from "react";
import type { TrackEvent } from "src/state/Track/TrackCubit";
import { authenticationState, tracker } from "src/state/state";
import { AppQueryPopupsController } from "../AppQueryPopupsBloc";
import SessionConfirmation from "../../SessionConfirmation/SessionConfirmation";
import { useBlocNext } from "@blac/react";
import UserPreferencesCubit from "src/state/UserPreferencesCubit/UserPreferencesCubit";

const SessionConfirmationDialog: FC<{
  returnUrl: string;
}> = ({ returnUrl }) => {
  const [, userPreferences] = useBlocNext(UserPreferencesCubit);
  const handleConfirmSession = () => {
    tracker.track("Session Confirmed" as TrackEvent);
    AppQueryPopupsController.closePopup();
  };

  const handleLogOut = () => {
    tracker.track("Session Logged Out" as TrackEvent);

    void authenticationState.logout().then(() => {
      AppQueryPopupsController.closePopup();

      window.location.href = returnUrl;
    });
  };

  return (
    <SessionConfirmation
      firstName={userPreferences.firstName}
      lastName={userPreferences.lastName}
      onConfirmed={handleConfirmSession}
      onLogout={handleLogOut}
    />
  );
};

export default SessionConfirmationDialog;
